import { render, staticRenderFns } from "./OrganAllocationSummary.vue?vue&type=template&id=702dc996"
import script from "./OrganAllocationSummary.vue?vue&type=script&lang=js"
export * from "./OrganAllocationSummary.vue?vue&type=script&lang=js"
import style0 from "./OrganAllocationSummary.vue?vue&type=style&index=0&id=702dc996&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports